export default __webpack_public_path__ + "static/media/ATTAleckSans_Bd.fdccdbb6.ttf";